import { useEffect, useState } from "react";

function useIsMobile() {
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        // Function to update height
        const updateHeight = () => {
            setHeight(window.innerHeight);
        };

        // Add event listener
        window.addEventListener("resize", updateHeight);

        // Clean up
        return () => window.removeEventListener("resize", updateHeight);
    }, []);

    const [width, setWidth] = useState<number>(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    const isMobile = width <= 768;

    return { isMobile, height, width };
}

export default useIsMobile;
